"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _downloadConsent = require('shared/services/downloadConsent');

// Web and desktop remember the acknowledgement in this browser profile.
// Reading localStorage itself can throw (blocked site data); the shared
// store then asks every time.
 const downloadConsent = _downloadConsent.createDownloadConsent.call(void 0, {
  getItem: key => window.localStorage.getItem(key),
  setItem: (key, value) => window.localStorage.setItem(key, value),
}); exports.downloadConsent = downloadConsent
